(function () {
  function cleanLabel(link) {
    return (link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function normaliseFindATileLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('a[href="/collections/all"], a[href$="/collections/all"]').forEach(function (link) {
      var label = cleanLabel(link);
      if (label === 'find a tile' || label === 'browse tiles') {
        link.setAttribute('href', '/pages/find-a-tile');
      }
    });
  }

  function init(root) {
    normaliseFindATileLinks(root || document);

    if (window.location.pathname === '/collections/all') {
      window.location.replace('/pages/find-a-tile' + window.location.search + window.location.hash);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();